var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-pagination flex"},[_vm._v(" Страница "+_vm._s(_vm.currentPage)+" из "+_vm._s(_vm.countPages)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }